import { Link } from "react-router-dom";
import { ArrowRight, Check, Columns2, DoorClosed, DoorOpen, Grid2x2, MessageCircle, PanelLeft, PanelsTopLeft } from "lucide-react";
import { QUICK_START, quoteHref } from "../../data/homeContent";
import { trackEvent } from "../../lib/api";
import { SectionHeading } from "./CtaButtons";

const ICONS = { Grid2x2, Columns2, PanelLeft, PanelsTopLeft, DoorOpen, DoorClosed, MessageCircle };
const STEPS = ["Kies wat u wilt laten plaatsen", "Beantwoord een paar korte vragen", "Ontvang uw persoonlijke prijsindicatie"];

export const QuickStart = () => (
  <section id="prijsindicatie" aria-labelledby="qs-title" className="section relative scroll-mt-24 overflow-hidden bg-maas-soft" data-testid="home-quickstart">
    <div className="hero-grid absolute inset-0 opacity-70" aria-hidden="true" />
    <div className="container-tight relative grid items-start gap-10 lg:grid-cols-12 lg:gap-14">
      <div className="lg:col-span-5">
        <SectionHeading id="qs-title" eyebrow="Direct een richtprijs" title="Waarvoor wilt u een prijsindicatie?"
          lead="Kies een product en beantwoord een paar korte vragen over uw woning. Foto's van uw huidige kozijnen mogen, maar hoeven niet." />
        <ol className="mt-8 space-y-4">
          {STEPS.map((s, i) => (
            <li key={s} className="flex items-center gap-4">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white font-display text-[15px] font-bold text-maas ring-1 ring-maas/20">{i + 1}</span>
              <span className="text-[15.5px] font-medium text-ink">{s}</span>
            </li>
          ))}
        </ol>
      </div>
      <div className="lg:col-span-7">
        <div className="card p-4 sm:p-6" style={{ boxShadow: "var(--shadow-2)" }}>
          <p className="px-1 text-[14px] font-semibold text-ink">Stap 1 · Wat wilt u laten plaatsen?</p>
          <ul className="mt-4 grid gap-3 sm:grid-cols-2">
            {QUICK_START.map((o) => {
              const Icon = ICONS[o.icon];
              return (
                <li key={o.onderwerp} className={o.wide ? "sm:col-span-2" : ""}>
                  <Link to={quoteHref(o.onderwerp)} onClick={() => trackEvent("cta_quote_click", { location: `quickstart-${o.onderwerp}` })}
                    data-testid={`quickstart-${o.onderwerp}`} className="qs-tile group">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-slate-50 text-ink ring-1 ring-slate-200 transition-colors duration-200 group-hover:bg-maas group-hover:text-white group-hover:ring-maas">
                      <Icon className="h-5 w-5" aria-hidden="true" />
                    </span>
                    <span className="flex-1 text-[15px] font-semibold text-ink">{o.label}</span>
                    <ArrowRight className="h-4 w-4 text-slate-400 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:text-maas" aria-hidden="true" />
                  </Link>
                </li>
              );
            })}
          </ul>
          <p className="mt-5 flex flex-wrap gap-x-5 gap-y-1.5 px-1 text-[13.5px] text-slate-500">
            {["Vrijblijvend", "Geen verplichte afspraak", "Foto's optioneel"].map((t) => (
              <span key={t} className="inline-flex items-center gap-1.5"><Check className="h-3.5 w-3.5 text-maas" aria-hidden="true" /> {t}</span>
            ))}
          </p>
        </div>
      </div>
    </div>
  </section>
);
